import React, { FC, useContext, useMemo } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import { routes } from "@app/routing";
import {
  BlueHeader,
  InformationCard,
  SpinnerView,
  TestInformationCard,
} from "@app/components";
import { TestDetailsContext } from "@app/provider/testData";
import "./testInformation.scss";

const messages = defineMessages({
  testInformationPageHeader: {
    id: "testInformationPageHeader",
    defaultMessage: "Test Information",
  },
});

const TestInformationPage: FC = () => {
  const intl = useIntl();
  const location = useLocation();

  const { isLoading, getTestDetails, getOrderUidPublic, getTestUid } =
    useContext(TestDetailsContext);

  const testDetails = getTestDetails();

  const content = useMemo(
    () =>
      testDetails ? (
        <TestInformationCard testDetailsInformation={testDetails} />
      ) : null,
    [testDetails]
  );

  return (
    <div className="test-information-page">
      <BlueHeader
        arrowRoute={routes.testDetailsPage(getOrderUidPublic(), getTestUid())}
        arrowState={location.state}
        title={intl.formatMessage(messages.testInformationPageHeader)}
      />
      <SpinnerView isLoading={isLoading} />
      <div className="test-information-page__content">
        {testDetails && <InformationCard content={content} />}
      </div>
    </div>
  );
};

export default TestInformationPage;
